<eess-bienvenido></eess-bienvenido>

<fenix-mensaje
            mensaje="{{configClienteExiste.mensaje}}"
            [mostrarAyuda]="false"
            titulo="{{configClienteExiste.titulo}}"
            tipo="warning">
</fenix-mensaje>

<div class="row">
  <div class="col-12 d-flex ta-c jc-c fw-w px-0 pl-md-7">
    <div class="col-12 col-md-auto pr-md-2 pl-0 pr-0">
      <bch-button [text]="'CONTINUAR COMO INVITADO'" [loading]="" (clicked)="continueAsGuess()"
                  class="btn-neutral"></bch-button>
    </div>
    <div class="col-12 col-md-auto pl-0 pl-md-2 mb-md-0 pr-0">
      <bch-button [text]="'INGRESAR COMO CLIENTE'" [loading]="" (clicked)="toggleActive()"
                  class="btn-neutral"></bch-button>
    </div>
  </div>
</div>

<div class="col-12">
  <bch-alert *ngIf="errorServicioEquifax"
              type="alert-warning"
              class="mb-3 bch-alert--small"
              hideIcon = false
              title="{{errorServicioEquifax}}">
  </bch-alert>
</div>
